import { render, staticRenderFns } from "./appFooter.vue?vue&type=template&id=40bb9e2f&scoped=true&"
var script = {}
import style0 from "./appFooter.vue?vue&type=style&index=0&id=40bb9e2f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bb9e2f",
  null
  
)

export default component.exports